import { useState } from "react";
import useApiActions from "../../../hooks/api-actions.hook";

const useSelectToolSearchData = ({ techTypeEnum, showAll, searchText }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const { getAllIntegrationsByTechType } = useApiActions();

  const getIntegrations = async () => {
    setIsLoading(true);
    const response = await getAllIntegrationsByTechType({ technologyTypeEnum: techTypeEnum, showAll, searchText });
    setData({
      ...response,
      ...(!response?.Integration_List && { Integration_List: [] }),
    });
    setIsLoading(false);
  }

  return { data, isLoading, getIntegrations };
}

export default useSelectToolSearchData;
